import { PILLARS, IMAGES } from "../../content/site";
import { MaskLines, Reveal, ClipImage } from "../motion";
import { Eyebrow } from "../Brand";

const THEMES = [
  { bg: "bg-[#090909]", word: "text-[#F6F2F0]", accent: "text-[#B8324E]", image: IMAGES.prayer, alt: "A man kneels in prayer at the altar rail, head bowed beneath a prayer shawl" },
  { bg: "bg-[#171416]", word: "outline-text", accent: "text-[#B8324E]", image: IMAGES.fellowship, alt: "Two believers standing side by side in the pews during worship, one with an arm around the other" },
  { bg: "bg-[#781C31]", word: "text-[#F6F2F0]", accent: "text-[#090909]" },
];

function Pillar({ p, i }) {
  const t = THEMES[i];
  return (
    <article
      className={`${t.bg} relative overflow-hidden border-t border-[#F6F2F0]/10`}
      data-testid={`pillar-${p.word.toLowerCase()}`}
    >
      <div className="mx-auto grid max-w-[1440px] gap-10 px-5 py-20 sm:px-8 lg:grid-cols-12 lg:items-center lg:px-12 lg:py-24">
        <div className={t.image ? "lg:col-span-7" : "lg:col-span-9"}>
          <p className="font-display text-sm tracking-[0.3em] text-[#F6F2F0]/70">0{i + 1} / 03</p>
          <MaskLines
            as="h3"
            lines={[
              { text: p.word, className: t.word },
              { text: "God.", className: t.accent },
            ]}
            className="mt-4 font-display text-[24vw] font-bold uppercase leading-[0.8] tracking-[-0.03em] sm:text-[18vw] lg:text-[12rem] xl:text-[14rem]"
          />
        </div>
        <Reveal className={`flex flex-col gap-8 ${t.image ? "lg:col-span-5" : "lg:col-span-3"}`}>
          {t.image && <ClipImage src={t.image} alt={t.alt} className="aspect-[4/5] w-full max-w-[320px]" imgClassName="grayscale-[35%]" />}
          <p className="max-w-md text-lg leading-relaxed text-[#F6F2F0]">{p.text}</p>
          <blockquote className="max-w-md border-l-2 border-[#F6F2F0]/30 pl-5">
            <p className="font-serif-i text-2xl leading-snug text-[#F6F2F0]/90">"{p.verse}"</p>
            <cite className="mt-2 block text-xs not-italic uppercase tracking-[0.2em] text-[#F6F2F0]/70">{p.ref}</cite>
          </blockquote>
        </Reveal>
      </div>
    </article>
  );
}

export function Pillars() {
  return (
    <section aria-labelledby="pillars-title" data-testid="home-pillars">
      <div className="mx-auto max-w-[1440px] px-5 pb-8 pt-24 sm:px-8 lg:px-12 lg:pt-32">
        <Eyebrow>Three Pillars</Eyebrow>
        <h2 id="pillars-title" className="mt-6 max-w-3xl font-display text-3xl font-semibold uppercase leading-tight tracking-tight text-[#F6F2F0] sm:text-4xl">
          Everything we are rests on three words of response to God.
        </h2>
      </div>
      <div className="relative">
        {PILLARS.map((p, i) => <Pillar key={p.word} p={p} i={i} />)}
      </div>
    </section>
  );
}
